import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AppConfig } from '../../config/app-config';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';
import * as fromApp from '../../shared/store/app.reducer';
import { Logout } from '../../auth/store/actions/auth.actions';

@Component({
  selector: 'app-fake-store',
  templateUrl: './fake-store.component.html',
  styleUrls: ['./fake-store.component.css'],
})
export class FakeStoreComponent implements OnInit {
  registerActivity: FormGroup;

  result: string;

  statusCode: string;

  userInfo = null;

  imagePath = null;

  authState: Observable<any>;

  isAuthenticated = false;

  constructor(
    private http: HttpClient,
    private store: Store<fromApp.AppState>
  ) {
    this.authState = this.store.select('auth');
  }

  ngOnInit() {
    this.registerActivity = new FormGroup({
      activityId: new FormControl(null, Validators.required),
    });
    this.authState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.userInfo = state.userInfo;
    });

    this.imagePath = AppConfig.settings.env.logoFile;
  }

  onSimulateRegister() {
    this.http
      .post<any>(
        `${AppConfig.settings.apiServer.details.remoteHost}/lms/inbound/activity/${this.registerActivity.value.activityId}/cap_member_id/${this.userInfo.userCapNumber}`,
        null
      )
      .subscribe(
        (response) => {
          this.statusCode = '200';
          this.result = response;
          console.log(response);
        },
        (err) => {
          this.statusCode = err.status;
          this.result = err.error.text ? err.error.text : err.error;
        }
      );
  }

  logout() {
    this.store.dispatch(new Logout());
  }
}
